exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-propertyPanel{font-size:14px;display:flex;flex-direction:column;background:#fff;min-width:400px;padding:0 24px;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,.1)}.ba-common-propertyPanel__panelTitle{line-height:48px;width:100%;font-weight:600;vertical-align:middle}.ba-common-propertyPanel .ba-common-tabList{height:40px;margin-bottom:24px}.ba-common-propertyPanel .ba-common-tabList__inner{padding:0}.ba-common-propertyPanel__buttonSection{display:flex;height:64px;align-items:center;flex-direction:row-reverse}.ba-common-propertyPanel__buttonSection__rightButton{align-self:flex-end}", ""]);

// exports
exports.locals = {
	"propertyPanelClassName": "\"ba-common-propertyPanel\""
};